import _axios from '@/utils/request'
const hospitalServices = {
    // 医院分页列表
    getHospitalList (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/hospital/pageHospital`,
            params
        )
    },
    // 不分页医院列表
    getAllHospitalList (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/hospital/listHospital`,
            params
        )
    },
    // 搜索获取所有互联网医院不分页列表
    getAllInterHospitalList (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/hospital/listAllHospital`,
            params
        )
    },
    // 医院详情
    getHospitalDetail (hospitalId) {
        return _axios('get', `/ms-shulan-hospital/v1/hospital/${hospitalId}`)
    },

    // 医生集团列表
    getHospitalGroupList (params) {
        return _axios('post', `/ms-shulan-hospital/v1/group/pageGroup`, params)
    },
    // 所有医生集团
    getAllHospitalGroupList (params) {
        return _axios('post', `/ms-shulan-hospital/v1/group/list`, params)
    },

    // 新增医生集团
    addHospitalGroup (params) {
        return _axios('post', `/ms-shulan-hospital/v1/group`, params)
    },

    // 修改医生集团
    updateHospitalGroup (params) {
        return _axios('put', `/ms-shulan-hospital/v1/group`, params)
    },

    // 科室列表
    getDeptList (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/department/pageDepartment`,
            params
        )
    },

    // 所有科室列表
    getAllDeptList (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/department/listDepartment`,
            params
        )
    },

    // 科室树状
    getTreeDeptList (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/department/treeDepartment`,
            params
        )
    },

    // 验证科室在当前医院是否重复
    checkDeptUnique (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/department/checkDepartmentName`,
            params
        )
    },

    // 编辑科室
    saveDept (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/department/saveOrUpdateBatchDepartment`,
            params
        )
    },

    // 科室详情
    getDeptDetail (deptId) {
        return _axios('get', `/ms-shulan-hospital/v1/department/${deptId}`)
    },

    // 判断科室是否关联医生
    judgeDeptHaveDoctor (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/department/checkDepartmentDoctor`,
            params
        )
    },

    // 删除科室
    deleteDept (deptId) {
        return _axios('delete', `/ms-shulan-hospital/v1/department/${deptId}`)
    },

    // 新增医院
    createHospital (params) {
        return _axios('post', `/ms-shulan-hospital/v1/hospital`, params)
    },
    // 修改医院
    editHospital (params) {
        return _axios('put', `/ms-shulan-hospital/v1/hospital`, params)
    },
    // 获取角色列表
    getRoleList () {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/sys/listRole`
        )
    },
    // 医生分页列表
    getDoctorList (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/doctor/pageDoctor`,
            params
        )
    },
    // 新增医生
    addDoctor (params) {
        return _axios(
            'post',
            `/ms-shulan-hospital/v1/doctor`,
            params
        )
    },
    // 编辑医生
    editDoctor (params) {
        return _axios(
            'put',
            `/ms-shulan-hospital/v1/doctor`,
            params
        )
    },
    // 获取医生详情
    getDoctorDetail (iuid) {
        return _axios('get', `/ms-shulan-hospital/v1/doctor/${iuid}`)
    },
    // 图片上传
    // imgUpload (hospitalId, iuid) {
    //     return _axios('post', `/ms-hoc-video/v1/image/upload?hospitalId=${hospitalId}&iuid=${iuid}&ImageType=DOCTOR_INFO_IMAGE`)
    // }
    imgUpload (formData, hospitalId, iuid) {
        return _axios(
            'post',
            `/ms-hoc-video/v1/image/upload?hospitalId=${hospitalId}&iuid=${iuid}&ImageType=DOCTOR_INFO_IMAGE`,
            formData
        )
    }
}
export default hospitalServices
